export function safeNotificationReturn(value) {
  if (typeof value !== 'string') return null;
  return /^\/quiz\/daily\/[0-9a-f-]{36}$/i.test(value) ? value : null;
}
export function currentNotificationReturn() {
  return safeNotificationReturn(window.location.pathname);
}
export function loginDestination(returnTo) {
  const safe = safeNotificationReturn(returnTo);
  return safe ? '/login?returnTo=' + encodeURIComponent(safe) : '/login';
}
